import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const moduleRegistration: ApiFunc<`${typeof API.MODULE_REGISTRATION}{id}`, 'get'> = data =>
  instance.get(`${API.MODULE_REGISTRATION}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const moduleRegistrationCreate: ApiFunc<`${typeof API.MODULE_REGISTRATION}`, 'post'> = data =>
  instance.post(API.MODULE_REGISTRATION, data)

export const moduleRegistrationRegister: ApiFunc<`${typeof API.MODULE_REGISTRATION_REGISTER}`, 'post'> = data =>
  instance.post(API.MODULE_REGISTRATION_REGISTER, data)

export const moduleRegistrationDelete: ApiFunc<`${typeof API.MODULE_REGISTRATION}{id}`, 'delete'> = data =>
  instance.delete(`${API.MODULE_REGISTRATION}${'id' in data ? prop('id', data) : data?.name}`)

export const moduleRegistrationList: ApiFunc<`${typeof API.MODULE_REGISTRATION}`, 'get'> = data =>
  instance.get(API.MODULE_REGISTRATION, {
    params: data,
  })

export const moduleRegistrationAll: ApiFunc<`${typeof API.MODULE_REGISTRATION_ALL}`, 'get'> = data =>
  instance.get(API.MODULE_REGISTRATION_ALL, {
    params: data,
  })
